import { mobiClient } from '@/services/axiosConfig'
import { PreorderReq, PreorderRes } from './types'

export const submitPreorder = async (req: PreorderReq): Promise<PreorderRes | undefined> => {
  try {
    const res = await mobiClient.post('/preorder', req)
    return res.data
  } catch (e) {
    console.error(e)
  }
}
